import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "top-bar-wrap"
}
const _hoisted_2 = { class: "topbar" }
const _hoisted_3 = { class: "p-menubar-list" }
const _hoisted_4 = {
  key: 1,
  class: "top-bar-wrap"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mainlogo" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Manager Client")
], -1)
const _hoisted_6 = {
  key: 0,
  class: "p-menubar-list"
}
const _hoisted_7 = {
  key: 1,
  class: "p-menubar-list"
}
const _hoisted_8 = {
  class: "p-menubar-list",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "image" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "info" }
const _hoisted_13 = { class: "lead text-muted" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("strong", null, "Email:", -1)
const _hoisted_15 = { class: "lead text-muted" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, "Store name:", -1)
const _hoisted_17 = { class: "lead text-muted" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("strong", null, "User role:", -1)

import { useAuth0 } from '@auth0/auth0-vue';
import { onMounted, ref, watch } from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import { useRouter } from 'vue-router';
import { useStore } from "../store";
import { computed } from 'vue';
import ApiService from "@/service/api.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const store = useStore();
const auth0 = useAuth0();
const router = useRouter();
const visible = ref(false);
const role = computed(() => store.state.role);
const storename = computed(() => store.state.storename);
const { user, isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();

onMounted(async () => {
  if (isAuthenticated.value === true) {
    const accessToken = await getAccessTokenSilently();
    await getUserInfo(accessToken);
    await getStoreDetails(accessToken);
    checkStoreStatus();
  }
})

// watch isLoading and isAuthenticated object to handle auth0 successful login - for initial login
const stop = watch([isLoading, isAuthenticated], async ([loading, auth]) => {
  if (!loading && auth) {
    const accessToken = await getAccessTokenSilently();
    await getUserInfo(accessToken);
    await getStoreDetails(accessToken);
    checkStoreStatus();
    stop();
  }
});

const checkStoreStatus = () => {
  const role = store.state.role;
  const storestatus = store.state.storestatus;
  if (role === 'StoreAdmin' && storestatus === 'Disable') {
    return router.push('/storedisable');
  }
}

const getUserInfo = async (accessToken: string) => {
  await ApiService.getUserInfo(accessToken);
}

const getStoreDetails = async (accessToken: string) => {
  const role = store.state.role;
  const allowedRoles = ['SupportAdmin', 'StoreAdmin'];
  if (allowedRoles.includes(role) === false) {
    return router.push('/storedisable');
  }
  await ApiService.getStoreDetails(accessToken, store.state.storeid);
}

const supportAdminMenuEnterprise = ref([
    {
        label: 'EnterpriseAdmin Users',
        path: '/enterpriseusers'
    }
]);

const supportAdminMenuStore = ref([
    {
        label: 'Stores',
        path: '/stores'
    },
    {
        label: 'StoreAdmin Users',
        path: '/adminusers'
    }
]);

const storeAdminMenu = ref([
  {
    label: 'Store Users',
    path: '/storeusers'
  }
])

/**
 * Menu list by role, new roles can be added here
 */
const menus = {
  StoreAdmin: storeAdminMenu.value
};

const logout = () => {
  sessionStorage.removeItem('vuex');
  localStorage.clear();
  auth0.logout({
    returnTo: window.location.origin
  });
};

const login = () => {
  auth0.loginWithRedirect()
}

/**
 * Menu items dynamically by role
 */
const getMenuItems = () => {
  return menus[role.value];
}

/**
 * Navigate to different pages
 * @param path 
 */
 const navigateTo = (path: string) => {
    router.push(path);
}

return (_ctx: any,_cache: any) => {
  const _component_Menubar = _resolveComponent("Menubar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (!_unref(isAuthenticated) && !_unref(isLoading))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Menubar, null, {
            end: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, [
                _createVNode(_unref(Button), {
                  class: "p-menubar-item",
                  label: "Login",
                  onClick: login
                })
              ])
            ]),
            _: 1
          })
        ])
      ]))
    : (_unref(isAuthenticated))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(['topbar', 'auth', role.value])
          }, [
            _hoisted_5,
            _createVNode(_component_Menubar, null, {
              start: _withCtx(() => [
                (role.value === 'SupportAdmin')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_Dropdown, {
                        autoOptionFocus: false,
                        options: supportAdminMenuStore.value,
                        optionLabel: "label",
                        placeholder: "Stores",
                        class: "mainNav",
                        onChange: _cache[0] || (_cache[0] = (event) => navigateTo(event.value.path))
                      }, null, 8, ["options"]),
                      _createVNode(_component_Dropdown, {
                        autoOptionFocus: false,
                        options: supportAdminMenuEnterprise.value,
                        optionLabel: "label",
                        placeholder: "Enterprises",
                        class: "mainNav",
                        onChange: _cache[1] || (_cache[1] = (event) => navigateTo(event.value.path))
                      }, null, 8, ["options"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMenuItems(), (item) => {
                        return (_openBlock(), _createBlock(_unref(Button), {
                          class: "p-menubar-item",
                          onClick: ($event: any) => (navigateTo(item.path)),
                          key: item.index
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]))
              ]),
              end: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  (role.value === 'SupportAdmin')
                    ? (_openBlock(), _createBlock(_unref(Button), {
                        key: 0,
                        class: "p-button p-component p-menubar-item sml",
                        label: "User Search",
                        type: "button",
                        severity: "secondary",
                        onClick: _cache[2] || (_cache[2] = (event) => navigateTo('/users'))
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("img", {
                    src: _unref(user)?.picture,
                    onClick: _cache[3] || (_cache[3] = () => { visible.value = true;}),
                    alt: "User's profile picture",
                    class: "border-circle img-fluid profile-picture"
                  }, null, 8, _hoisted_9)
                ]),
                _createVNode(_unref(Dialog), {
                  class: "profile",
                  visible: visible.value,
                  "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((visible).value = $event)),
                  modal: "",
                  header: "Profile"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        src: _unref(user)?.picture,
                        alt: "User's profile picture",
                        class: "border-circle img-fluid profile-picture"
                      }, null, 8, _hoisted_11)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("h2", null, _toDisplayString(_unref(user)?.name), 1),
                      _createElementVNode("p", _hoisted_13, [
                        _hoisted_14,
                        _createTextVNode(" " + _toDisplayString(_unref(user)?.email), 1)
                      ]),
                      _createElementVNode("p", _hoisted_15, [
                        _hoisted_16,
                        _createTextVNode(" " + _toDisplayString(storename.value), 1)
                      ]),
                      _createElementVNode("p", _hoisted_17, [
                        _hoisted_18,
                        _createTextVNode(" " + _toDisplayString(role.value), 1)
                      ]),
                      _createVNode(_unref(Button), {
                        label: "log out",
                        class: "logout",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => {logout();})
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["visible"])
              ]),
              _: 1
            })
          ], 2)
        ]))
      : _createCommentVNode("", true)
}
}

})